jQuery(document).ready(function ($) {
	// Animate on Scroll
	AOS.init();

	// Match Height
	$(
		".learn-more-content h1, .learn-more-content h2, .learn-more-content h3, .learn-more-content h4, .learn-more-content h5, .learn-more-content 6"
	).matchHeight();
	$(".learn-more-content p").matchHeight();

	// Scroll to Top Button in Footer
	$(".back-to-top").click(function (e) {
		e.preventDefault();
		$("html, body").animate({ scrollTop: 0 }, 800);
		return false;
	});

	// Mobile Walker Menu
	$("#morphSvg").on("click", function () {
		// Slide toggle the #mobile-menu visibility
		$("#mobile-menu").slideToggle(500, function () {
			if ($("#mobile-menu").is(":visible")) {
				// Morph the SVG to the "X" shape
				$("#circle1").attr(
					"transform",
					"matrix(0.7071, -0.7071, 0.7071, 0.7071, 44.2177, 237.924)"
				);

				$("#circle2").css("opacity", "0.0086").css("display", "none");

				$("#circle3").attr(
					"transform",
					"matrix(0.7071, 0.7071, -0.7071, 0.7071, 69.4289, 49.7237)"
				);

				// Disable scrolling
				$("body").addClass("no-scroll");
			} else {
				// Reset SVG to hamburger shape
				$("#circle1").attr(
					"transform",
					"matrix(1,0,0,1,17.813995361328125,218.572998046875)"
				);

				$("#circle2").css("opacity", "1").css("display", "block");

				$("#circle3").attr(
					"transform",
					"matrix(1,0,0,1,17.813995361328125,54.67300033569336)"
				);

				// Re-enable scrolling
				$("body").removeClass("no-scroll");
			}
		});
	});
	$("#mobile-menu li.has-sub > a").on("click", function () {
		$(this).removeAttr("href");
		var element = $(this).parent("li");
		if (element.hasClass("open")) {
			element.removeClass("open");
			element.find("li").removeClass("open");
			element.find("ul").slideUp();
		} else {
			element.addClass("open");
			element.children("ul").slideDown();
			element.siblings("li").children("ul").slideUp();
			element.siblings("li").removeClass("open");
			element.siblings("li").find("li").removeClass("open");
			element.siblings("li").find("ul").slideUp();
		}
	});

	// Mobile Sticky Sub Menu
	$(".toggle-mobile-services-menu").on("click", function () {
		$(".mobile-services-menu-content").slideToggle();
		$(this).toggleClass("active");
	});

	// FAQ Scrollspy
	document.addEventListener("DOMContentLoaded", function () {
		const links = document.querySelectorAll(".sidebar-categories a"); // Sidebar links
		const sections = document.querySelectorAll("h2"); // H2 elements on the right

		// Assign IDs if missing
		sections.forEach((section, index) => {
			if (!section.id) {
				section.id = "section-" + (index + 1);
			}
		});

		// Update active link on scroll
		window.addEventListener("scroll", () => {
			let current = "";

			sections.forEach((section) => {
				const sectionTop = section.getBoundingClientRect().top;
				if (sectionTop <= 150) {
					// Adjust 150 if needed for offset
					current = section.getAttribute("id");
				}
			});

			links.forEach((link) => {
				link.classList.remove("active-link");
				if (link.getAttribute("href") === "#" + current) {
					link.classList.add("active-link");
				}
			});
		});

		// Smooth scroll for links
		links.forEach((link) => {
			link.addEventListener("click", function (e) {
				e.preventDefault();
				const targetId = this.getAttribute("href").slice(1);
				const targetElement = document.getElementById(targetId);
				targetElement.scrollIntoView({
					behavior: "smooth",
					block: "start",
				});
			});
		});
	});

	// Open Modal
	$("a[href='#openModal']").on("click", function (e) {
		e.preventDefault(); // Prevent default anchor behavior
		$("#overlayModal").addClass("active");
		$(".modal-content").addClass("active");
		$("body").addClass("no-scroll");
	});

	// Close Modal
	$("#closeModal").on("click", function () {
		$("#overlayModal").removeClass("active");
		$(".modal-content").removeClass("active");
		$("body").removeClass("no-scroll");
	});

	// Close Modal on Overlay Click
	$("#overlayModal").on("click", function (e) {
		if ($(e.target).is("#overlayModal")) {
			$(this).removeClass("active");
			$(".modal-content").removeClass("active");
			$("body").removeClass("no-scroll");
		}
	});

	// Handle top-level menu items with children
	$("#menu-header-menu > li.menu-item-has-children > a").click(function (e) {
		var parentMenuItem = $(this).parent(); // Get the parent <li> element

		// Check if this menu item has children
		if (parentMenuItem.hasClass("menu-item-has-children")) {
			e.preventDefault(); // Prevent navigation only for parent items with children

			// Toggle the first-level submenu of the clicked parent
			parentMenuItem
				.toggleClass("clicked")
				.children(".sub-menu") // Select only the first-level `.sub-menu` directly under the clicked parent
				.slideToggle();

			// Close sibling menus and their first-level submenus, but leave nested submenus alone
			parentMenuItem
				.siblings()
				.removeClass("clicked")
				.children(".sub-menu") // Select only the first-level `.sub-menu` of siblings
				.slideUp();

			// Ensure any open child submenus within the clicked menu item remain open
			parentMenuItem
				.find(".sub-menu .clicked") // Find nested open submenus
				.children(".sub-menu") // Target their direct child `.sub-menu`
				.slideDown();
		}
	});

	document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
		anchor.addEventListener("click", function (e) {
			e.preventDefault();

			document.querySelector(this.getAttribute("href")).scrollIntoView({
				behavior: "smooth",
			});
		});
	});
});
